export const pageSizes = [
    { value: "3", label: "Show 3 items" },
    { value: "6", label: "Show 6 items" },
    { value: "9", label: "Show 9 items" },
    { value: "12", label: "Show 12 items" },
    { value: "15", label: "Show 15 items" },
]
